module.exports = __webpack_public_path__ + "img/empty.9ecaf1ed.png";